import { render, staticRenderFns } from "./add-cashier-platform.vue?vue&type=template&id=4083b145&scoped=true"
import script from "./add-cashier-platform.vue?vue&type=script&lang=js"
export * from "./add-cashier-platform.vue?vue&type=script&lang=js"
import style0 from "./add-cashier-platform.vue?vue&type=style&index=0&id=4083b145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083b145",
  null
  
)

export default component.exports